import NotAllowedPage from "./not-allowed-page"
export default NotAllowedPage
